import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-advertisers',
    templateUrl: './advertisers.component.html',
    styleUrls: ['./advertisers.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdvertisersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
